/**
 * @generated SignedSource<<affa126fc7680ddddb52d77508817537>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileCancelationPolicy_item$data = {
  readonly cancelationPolicy: {
    readonly body: string | null;
    readonly header: string | null;
    readonly linkData: {
      readonly path: string | null;
      readonly text: string | null;
    };
  } | null;
  readonly " $fragmentType": "CheckoutMobileCancelationPolicy_item";
};
export type CheckoutMobileCancelationPolicy_item$key = {
  readonly " $data"?: CheckoutMobileCancelationPolicy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileCancelationPolicy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileCancelationPolicy_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CancelationPolicy",
      "kind": "LinkedField",
      "name": "cancelationPolicy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f464d932c76618cabda1e144d9d4accb";

export default node;
